import Easing from '../util/Easing';

export default class BIMLayer {
    constructor(main) {
        this.main = main;
        this.map = main.map;
        this.dm = main.map.dm;
       // 初始化记录实体数据
       this.entities = initEntity(this.dm);
    }

	/**
	 * 开启 BIM 场景的搭建过程动画
	 */
	startBuildAnimation() {
		if(!this.entities) return;
		const {
            bimEntitiesBlock,
			allBimEntities
		} = this.entities;

        if (this._animInprogress) {
            return;
        }
        this._animInprogress = true;

        let seq = [{
                parentNode: 'firstFloor',
                nodes: ['f1', 'f1glass', 'f1gate'],
                directions: ['top','top','top'],
                duration: 3000,
                delayStart: 500,
                flyToAnim: {
                    heading: 82.7542926758805,
                    height: 113.33886926287092,
                    pitch: -42.226656066382226,
                    position: [118.0418518823259, 24.615626598741038],
                    roll: 0.0034009843442435184,
                    animation: {
                        duration: 2000
                    }
                }
            },
            {
                nodes: ['f1Ceil'],
                directions: ['front'],
                duration: 1000,
                delayStart: 100,
            },
            {
                parentNode: 'secondFloor',
                nodes: ['f2', 'f2glass'],
                directions: ['top','top'],
                duration: 3000,
                delayStart: 500,
            },
            {
                nodes: ['tools'],
                directions: ['top'],
                duration: 1000,
                delayStart: 100,
                flyToAnim : {
                    heading: 142.02665189173214,
                    height: 95.18154581042457,
                    pitch: -36.712837884699375,
                    position: [118.04228000897679, 24.61611986615456],
                    roll: 0.0019451089299513669,
                    animation: {
                        duration: 1000
                    }
                }
            },
            {
                nodes: ['f2Ceil'],
                directions: ['front'],
                duration: 1000,
                delayStart: 100,
                flyToAnim: {
                    heading: 82.7542926758805,
                    height: 113.33886926287092,
                    pitch: -42.226656066382226,
                    position: [118.0418518823259, 24.615626598741038],
                    roll: 0.0034009843442435184,
                    animation: {
                        duration: 1000
                    }
                }
            },
            {
                parentNode: 'thirdFloor',
                nodes: ['f3', 'f3glass'],
                directions: ['top','top'],
                duration: 2000,
                delayStart: 500,
                flyToAnim: {
                    heading: 82.7542926258946,
                    height: 124.62022852454922,
                    pitch: -42.2266560593802,
                    position: [118.04180644431366, 24.615646997264836],
                    roll: 0.0034009856423597995,
                    animation: {
                        duration: 1000
                    }
                }
            },
            {
                parentNode: 'fourthFloor',
                nodes: ['f4', 'f4glass'],
                directions: ['top','top'],
                duration: 2000,
                delayStart: 500,
                flyToAnim: {
                    heading: 82.7542926029593,
                    height: 137.3396973060183,
                    pitch: -42.22665605616735,
                    position: [118.04172432712431, 24.615640156412198],
                    roll: 0.0034009862379820177,
                    animation: {
                        duration: 1000
                    }
                }
            },
            {
                nodes: ['f4Ceil'],
                directions: ['front'],
                duration: 1000,
                delayStart: 100,
            },
            {
                parentNode: 'fifthFloor',
                nodes: ['f5', 'f5glass', 'f5gate'],
                directions: ['top','top','top'],
                duration: 2000,
                delayStart: 500,
                flyToAnim: {
                    heading: 82.7542926029593,
                    height: 154.466390010711,
                    pitch: -42.22665605616733,
                    position: [118.04155473235231, 24.615614033868397],
                    roll: 0.0034009862379820177,
                    animation: {
                        duration: 1000
                    }
                }
            },
            {
                nodes: ['f5Ceil'],
                directions: ['front'],
                duration: 1000,
                delayStart: 100,
            },
            {
                parentNode: 'sixthFloor',
                nodes: ['f6', 'f6glass'],
                directions: ['top','top'],
                duration: 2000,
                delayStart: 500,
            },
            {
                nodes: ['f6Ceil'],
                directions: ['front'],
                duration: 1000,
                delayStart: 100,
            },
            {
                parentNode: 'seventhFloor',
                nodes: ['f7', 'f7glass'],
                directions: ['top','top'],
                duration: 2000,
                delayStart: 500,
                flyToAnim: {
                    heading: 82.754292918982,
                    height: 196.65685668538356,
                    pitch: -42.22665610043737,
                    position: [118.04124137564511, 24.6156131766537],
                    roll: 0.0034009780309842697,
                    animation: {
                        duration: 1000
                    }
                }
            },
            {
                parentNode: 'eighthFloor',
                nodes: ['f8', 'f8glass'],
                directions: ['top','top'],
                duration: 2000,
                delayStart: 500,
            },
            {
                nodes: ['f8Ceil'],
                directions: ['front'],
                duration: 1000,
                delayStart: 100,
            },
            {
                parentNode: 'topFloor',
                nodes: ['ftop'],
                directions: ['front'],
                duration: 1000,
                delayStart: 100,
            },
            {
                parentNode: 'topFloor',
                nodes: ['outFrame'],
                directions: ['bottom'],
                duration: 3000,
                delayStart: 1000,
            }
        ];

        // seq.reverse();

        this.setBIMEntityVisible(true);

        let animIndex = 0;
        let firstEnter = true;
		let nodes = seq[animIndex].nodes.map(tag => {
			return allBimEntities[tag];
		});
        let parentNode = seq[animIndex].parentNode ? bimEntitiesBlock[seq[animIndex].parentNode] : null;

        const animParams = {
            delay: seq[animIndex].delayStart,
            duration: seq[animIndex].duration,
            // easing: Easing.easeOutStrong,
            easing: t => t,
            action: v => {
                if(firstEnter) {
                    firstEnter = false;
                    nodes.forEach((node, index) => {
                        node.s('3d.clip.direction',  seq[animIndex].directions[index]);
                        node.s('3d.clip.percentage', 0);
                        node.s('3d.visible', true);
                    });
                    parentNode && parentNode.s('3d.visible', true);
                    if(seq[animIndex].flyToAnim) {
                        this.map.flyTo(seq[animIndex].flyToAnim);
                    }
                }
                nodes.forEach((node, index) => {
                    node.s('3d.clip.percentage', v);
                });
            },
            finishFunc: () => {
                if(this._animInprogress) {
                    animIndex++;
                    if(animIndex < seq.length) {
                        if(seq[animIndex].flyToAnim) {
                            this.map.flyTo(seq[animIndex].flyToAnim, () => {
                                firstEnter = true;
                                nodes = seq[animIndex].nodes.map(tag => {
                                    return allBimEntities[tag];
                                });
                                parentNode = seq[animIndex].parentNode ? bimEntitiesBlock[seq[animIndex].parentNode] : null;
                                this.buildAnim = ht.Default.startAnim(animParams);
                            });
                        }
                        else {
                            firstEnter = true;
                            nodes = seq[animIndex].nodes.map(tag => {
                                return allBimEntities[tag];
                            });
                            parentNode = seq[animIndex].parentNode ? bimEntitiesBlock[seq[animIndex].parentNode] : null;
                            this.buildAnim = ht.Default.startAnim(animParams);
                        }
                    }
                    else {
                        // 所有搭建结束后的执行操作写在这里
                        this.separateTimeout = setTimeout(() => {
                            this.runSeparateFloors();
                        }, 5000);
                    }
                }
            }
        }

        this.buildAnimTimeout = setTimeout(() => {
            if(seq[animIndex].flyToAnim) {
                this.map.flyTo(seq[animIndex].flyToAnim, () => {
                    this.buildAnim = ht.Default.startAnim(animParams);
                });
            }
        }, 3000);
	}

    /**
     * 停止建筑动画
     */
    stopBuildingAnimation() {
        if(this.buildAnimTimeout) {
            clearTimeout(this.buildAnimTimeout);
        }
        if(this.separateTimeout) {
            clearTimeout(this.separateTimeout);
        }
        if(this.buildAnim) {
            this.buildAnim.pause();
            this._animInprogress = false;
        }
        this.resetFloors();
    }
	
	/**
	 * BIM 模型的可视化设置
	 * @param {Boolean} isHide - 是否隐藏
	 */
	setBIMEntityVisible(isHide) {
		if(!this.entities) return;
		const {
            bimEntityBlockTags,
            bimEntitiesBlock,
		} = this.entities;

		bimEntityBlockTags.forEach(tag => {
			bimEntitiesBlock[tag].s('3d.visible', !isHide);
            bimEntitiesBlock[tag].eachChild(childNode => {
                childNode.s({
                    '3d.visible': false,
                    '3d.clip.percentage': 0
                });
            });
		});
	}

    /**
     * 执行楼层分离
     */
    runSeparateFloors(dir = 1) {
		if(!this.entities) return;
		const {
            bimEntityBlockTags,
            bimEntitiesBlock,
            allBimEntities
		} = this.entities;

        this.separate = true;
        this.separateBuildingAnim = null;
        const names = Object.keys(allBimEntities);
        const initPositions = {};
        names.forEach(name => {
            if(name === 'outFrame' || name === 'ftop' || name === 'tools') {    
                allBimEntities[name].s('3d.visible', false);
            }
            initPositions[name] = allBimEntities[name].p3();
        });

        this.separateBuildingAnim = [];
        const blockLen = bimEntityBlockTags.length;

        this.map.flyTo({
            heading: 47.24828036845223,
            height: 142.0943064395344,
            pitch: -10.343995281523707,
            position: [118.03905381581195, 24.613626176710405],
            roll: 0.0018948879945712704,
            animation: {
                duration: 2000
            }
        });

        bimEntityBlockTags.forEach((name,i) => {
            this.separateBuildingAnim[i] = ht.Default.startAnim({
                delay: 1000 * (dir === 1 ? (blockLen - i) : i),
                duration: 1000,
                easing: t => t,
                action: v => {
                    bimEntitiesBlock[name].eachChild((node,j) => {
                        const childNodeName = node.getTag();
                        const newPositions = [initPositions[childNodeName][0] + dir * 10 * (i + 1) * v , initPositions[childNodeName][1] + dir * 10 * (i + 1) * v, initPositions[childNodeName][2] + dir * 10 * (i + 1) * v];
                        node.p3(newPositions);
                    });

                },
                finishFunc: () => {
                    if(i === 0 && dir === 1) {
                        this.separateTimeout = setTimeout(() => {
                            this.runSeparateFloors(-1);
                        }, 5000);
                    }
                    if(i === blockLen - 1 && dir === -1) {
                        ['outFrame', 'ftop', 'tools'].forEach(name => {
                            allBimEntities[name].s('3d.visible', true);
                        });
                    }
                }
            });
        });
    }
    
    /**
     * 重置楼层
     */
    resetFloors() {
		const {
            initPosiotions,
            allBimEntities
		} = this.entities;
        if(this.separate) {
            this.separate = false;
            if(this.separateBuildingAnim) {     
                this.separateBuildingAnim.forEach(anim => {
                    anim.pause();
                });
                this.separateBuildingAnim = [];
                
                let names = Object.keys(allBimEntities);
                names.forEach(name => {
                    allBimEntities[name].p3(initPosiotions[name]);
                });
                
            }
        }
    }
}

/**
 * 初始化获取存储后面需要操作的实体对象
 * @param {dataModel} dm - 数据模型
 * @returns 
 */
function initEntity(dm) {
	const bimEntityBlockTags = [
		'firstFloor', 'secondFloor', 'thirdFloor', 'fourthFloor',
		'fifthFloor', 'sixthFloor', 'seventhFloor', 'eighthFloor',
		'topFloor'
	];

	let bimEntitiesBlock = {};
	let bimEntities = {};
	let allBimEntities = {};
    let initPosiotions = {};

	dm.each(node => {
		let tag = node.getTag();
		if(tag) {
			if(bimEntityBlockTags.indexOf(tag) > -1) {
				bimEntitiesBlock[tag] = node;
                bimEntities[tag] = [];
                node.eachChild(childNode => {
                    bimEntities[tag].push(childNode);
                    allBimEntities[childNode.getTag()] = childNode;
                    initPosiotions[childNode.getTag()] = childNode.p3();
                });
			}
		}
	});

	return {
		bimEntityBlockTags,
		bimEntitiesBlock,
		bimEntities,
        allBimEntities,
        initPosiotions
	};
}